const KEYS = {
  'Space': true,
  'PageUp': true,
  'PageDown': true,
  'End': true,
  'Home': true,
  'ArrowLeft': true,
  'ArrowUp': true,
  'ArrowRight': true,
  'ArrowDown': true,
};

export class UserScroll {
  constructor() {
    this._supportPassive = false;
    this._wheelOpt = false;
    this._preventDefault = this._preventDefault.bind(this);
    this._preventDefaultForScrollKeys = this._preventDefaultForScrollKeys.bind(this);
  }

  _preventDefault(evt) {
    evt.preventDefault();
  }

  _preventDefaultForScrollKeys(evt) {
    if (KEYS[evt.code]) {
      this._preventDefault(evt);
    }
  }

  init() {
    let isPassive = this._supportPassive;
    try {
      window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
        get() {
          isPassive = true;
        },
      }));
    // eslint-disable-next-line no-empty
    } catch (er) {}

    this._supportPassive = isPassive;
    this._wheelOpt = this._supportPassive ? {passive: false} : false;
    this._wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
  }

  disableScrolling() {
    window.addEventListener('DOMMouseScroll', this._preventDefault, false);
    window.addEventListener(this._wheelEvent, this._preventDefault, this._wheelOpt);
    window.addEventListener('touchmove', this._preventDefault, this._wheelOpt);
    window.addEventListener('keydown', this._preventDefaultForScrollKeys, false);
  }

  enableScrolling() {
    window.removeEventListener('DOMMouseScroll', this._preventDefault, false);
    window.removeEventListener(this._wheelEvent, this._preventDefault, this._wheelOpt);
    window.removeEventListener('touchmove', this._preventDefault, this._wheelOpt);
    window.removeEventListener('keydown', this._preventDefaultForScrollKeys, false);
  }
}
